<template>
    <div class="animated fadeIn master-form-page">
        <!-- Back Button -->
        <div class="mb-3">
            <button type="button" class="btn btn-back" @click="$router.go(-1)">
                <i class="fa fa-chevron-left mr-1"></i> Back
            </button>
        </div>

        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        
        <div v-else class="master-form-card">
            <h4 class="form-page-title">Edit Merk Barang</h4>
            
            <b-form @submit.prevent="openModalConfirm">
                <!-- DATA UMUM -->
                <div class="form-section-block">
                    <div class="form-section-header no-border">
                        <span class="section-accent-bar"></span>
                        <span class="section-label">DATA UMUM</span>
                    </div>

                    <b-row>
                        <b-col md="4" class="form-field-group">
                            <label class="field-label" for="inputTipePinjaman">Tipe Pinjaman</label>
                            <b-form-input
                                id="inputTipePinjaman"
                                :value="tipePinjamanName"
                                name="tipePinjaman"
                                class="field-input w-100"
                                disabled
                            ></b-form-input>
                        </b-col>
                        <b-col md="4" class="form-field-group">
                            <label class="field-label" for="selectJenisBarang">Jenis Barang</label>
                            <b-form-select 
                                id="selectJenisBarang"
                                v-model="input.jenisBarang" 
                                name="jenisBarang" 
                                :options="jenisBarang" 
                                value-field="id" 
                                text-field="name" 
                                class="field-select w-100"
                                required 
                                disabled
                            >
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Jenis Barang</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col md="4" class="form-field-group">
                            <label class="field-label" for="inputMerkBarang">Nama Merk Barang</label>
                            <b-form-input 
                                id="inputMerkBarang"
                                v-model="input.merkBarang" 
                                name="merkBarang" 
                                placeholder="Nama Merk Barang"
                                class="field-input w-100"
                                required
                            ></b-form-input>
                        </b-col>
                    </b-row>
                </div>

                <!-- SPESIFIKASI -->
                <div class="form-section-block">
                    <div class="form-section-header">
                        <span class="section-accent-bar"></span>
                        <span class="section-label">SPESIFIKASI</span>
                    </div>

                    <button type="button" class="btn btn-add-section" @click="addSpesifikasi" name="spesifikasiAddBtn">
                        <i class="fa fa-plus mr-1"></i> Spesifikasi
                    </button>

                    <div v-if="input.spesifikasi.length === 0" class="empty-dashed-box">
                        Belum ada Spesifikasi ditambahkan.
                    </div>
                    <div v-else>
                        <Spesifikasi 
                            v-for="item in input.spesifikasi" 
                            :key="item.index"
                            :spesifikasi="item" 
                            :length="input.spesifikasi.length" 
                            @remove="removeSpesifikasi(item.index, item.id)"
                        />
                    </div>
                </div>

                <!-- KONDISI -->
                <div class="form-section-block">
                    <div class="form-section-header">
                        <span class="section-accent-bar"></span>
                        <span class="section-label">KONDISI</span>
                    </div>

                    <button type="button" class="btn btn-add-section" @click="addKondisi" name="kondisiAddBtn">
                        <i class="fa fa-plus mr-1"></i> Kondisi
                    </button>

                    <div v-if="input.kondisi.length === 0" class="empty-dashed-box">
                        Belum ada Kondisi ditambahkan.
                    </div>
                    <div v-else>
                        <Kondisi 
                            v-for="item in input.kondisi" 
                            :key="item.index"
                            :kondisi="item" 
                            :length="input.kondisi.length" 
                            :isKendaraan="isKendaraan" 
                            @remove="removeKondisi(item.index, item.id)"
                        />
                    </div>
                </div>

                <!-- Actions Footer -->
                <div class="form-actions-footer">
                    <button type="submit" name="merkBarangUpdateBtn" class="btn btn-submit" :disabled="isSubmitting">
                        Kirim
                    </button>
                    <button type="button" class="btn btn-cancel" @click="$router.go(-1)">
                        Batal
                    </button>
                </div>
            </b-form>
        </div>

        <ModalConfirm 
            id="modal-confirm-edit" 
            title="Confirm Edit Merk Barang" 
            :isSubmitting="isSubmitting" 
            desc="Apakah anda yakin untuk mengubah merk barang ini?" 
            @submit="onSubmit" 
        />
    </div>
</template>

<script>
import Spesifikasi from '../../../components/spesifikasi/Spesifikasi'
import Kondisi from '../../../components/kondisi/Kondisi'

export default {
    name: 'edit-merk-barang',
    components: { 
        Spesifikasi, Kondisi
    },
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            input:{
                merkBarang: "",
                jenisBarang: null,
                spesifikasi: [],
                kondisi: [],
            },
            jenisBarang: [],
            merkBarang: null,
            indexSpesifikasi: 0,
            indexKondisi: 0,
            isKendaraan: false,
            deleteSpesifikasi: [],
            deleteKondisi: [],
        }
    },
    computed: {
        tipePinjamanName() {
            let jenis = this.jenisBarang.find(item => item.id == this.input.jenisBarang)
            if (jenis && jenis.jenisPinjaman) return jenis.jenisPinjaman.name
            let fromMerk = this.merkBarang && this.merkBarang.barangJenis && this.merkBarang.barangJenis.jenisPinjaman
            return fromMerk ? fromMerk.name : '-'
        }
    },
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getJenis = this.$axios.get("barang-jenis/").then(response => {
                this.jenisBarang = response.data
            })

            let getSingleMerkBarang = this.$axios.get(`barang-merk/${this.id}`).then(response => {
                this.merkBarang = response.data
                
                //----------------- Inisialisasi Data Merk Barang -----------------

                this.input.merkBarang = this.merkBarang.name
                this.input.jenisBarang = this.merkBarang.barangJenis.id

                let nameSpec, detailInfoSpec, nominalPSpec, nominalASpec, nominalAngka = null

                for (var x of this.merkBarang.spesifikasi) {
                    nameSpec = x.name
                    let nominalPSpec, nominalASpec, nominalAngka = null

                    if (x.nominalAngka == null) {
                        detailInfoSpec = "persen",
                        nominalPSpec = x.nominalPersen                            
                    } 
                    else {
                        nominalAngka = this.$helper.addThousandSeparator(x.nominalAngka);
                        detailInfoSpec = "nominal",
                        nominalASpec = nominalAngka
                    }

                    this.input.spesifikasi.push({
                        index: this.indexSpesifikasi,
                        id: x.id,
                        name: nameSpec,
                        detailInfo: detailInfoSpec,
                        nominalPersen: nominalPSpec,
                        nominalAngka: nominalASpec
                    })
                    this.indexSpesifikasi++
                }

                let nameMerk, ketMerk, namaSendiriMerk, dusMerk, detailInfoMerk, nominalPMerk, nominalAMerk, hargaMaksimalMerk= null

                for (var x of this.merkBarang.kondisi) {
                    nameMerk = x.name
                    ketMerk = x.keterangan
                    hargaMaksimalMerk = this.$helper.addThousandSeparator(x.hargaMaksimal)
                    let nominalPMerk, nominalAMerk, nominalAngka = null
                    
                    if (x.dus == null) {
                        if(x.namaSendiri == true) namaSendiriMerk = 0
                        else namaSendiriMerk = 1
                    } 
                    else {
                        if(x.dus == true) dusMerk = 0
                        else dusMerk = 1
                    }

                    if (x.nominalAngka == null) {
                        detailInfoMerk = "persen",
                        nominalPMerk = x.nominalPersen                            
                    } 
                    else {
                        nominalAngka = this.$helper.addThousandSeparator(x.nominalAngka);
                        detailInfoMerk = "nominal",
                        nominalAMerk = nominalAngka
                    }

                    if (dusMerk == null) dusMerk = 0
                    if (namaSendiriMerk == null) namaSendiriMerk = 0

                    this.input.kondisi.push({
                        index: this.indexKondisi,
                        id: x.id,
                        name: nameMerk,
                        keterangan: ketMerk,
                        dus: dusMerk,
                        namaSendiri: namaSendiriMerk,
                        detailInfo: detailInfoMerk,
                        nominalPersen: nominalPMerk,
                        nominalAngka: nominalAMerk,
                        hargaMaksimal: hargaMaksimalMerk
                    })
                    this.indexKondisi++
                }         
            })

            Promise.all([getJenis, getSingleMerkBarang]).then(() => {
                let jenis = this.jenisBarang.filter(item => item.id == this.input.jenisBarang)
                if (jenis && jenis.length > 0 && jenis[0].jenisPinjaman) {
                    let namaJenis = jenis[0].jenisPinjaman.name
                    if (namaJenis == 'Kendaraan') {
                        this.isKendaraan = true
                    } 
                    else if (namaJenis == 'Elektronik') {
                        this.isKendaraan = false
                    }
                }
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        //----------------- Fungsi Tambah Hapus Data Spesifikasi & Kondisi -----------------
        
        addSpesifikasi() {
            this.input.spesifikasi.unshift({ 
                index: this.indexSpesifikasi, 
                id: 0, 
                name: "", 
                detailInfo: "persen", 
                nominalPersen: null, 
                nominalAngka: null 
            })
            this.indexSpesifikasi++;
        },

        removeSpesifikasi(index, id) {
            this.input.spesifikasi = this.input.spesifikasi.filter(item => item.index != index)
            if (id && id !== 0) {
                this.deleteSpesifikasi.push(id)
            }
        },

        addKondisi() {
            this.input.kondisi.unshift({ 
                index: this.indexKondisi, 
                id: 0, 
                name: "", 
                dus: 0,
                namaSendiri: 0,
                keterangan: "",
                detailInfo: "persen",
                nominalPersen: null,
                nominalAngka: null,
                hargaMaksimal: 0
            })
            this.indexKondisi++;
        },

        removeKondisi(index, id) {
            this.input.kondisi = this.input.kondisi.filter(item => item.index != index)
            if (id && id !== 0) {
                this.deleteKondisi.push(id)
            }
        },


        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            var status = ""
            let payload = new FormData()

            //----------------- Append Data Jenis Barang -----------------

            for (var x of this.input.spesifikasi) {
                let nominal = this.$helper.removeThousandSeparator(x.nominal);
                payload.append('spesifikasiId', x.id)
                payload.append('spesifikasiName', x.name)
                if (x.detailInfo == "nominal") {
                    let nominalAngka = this.$helper.removeThousandSeparator(x.nominalAngka);
                    payload.append('spesifikasiNominalAngka', nominalAngka)
                    payload.append('spesifikasiNominalPersen', null)
                } 
                else {
                    payload.append('spesifikasiNominalPersen', x.nominalPersen)
                    payload.append('spesifikasiNominalAngka', null)
                }
            }

            for (var x of this.input.kondisi) {
                payload.append('kondisiId', x.id)
                payload.append('kondisiName', x.name)
                const nominalHargaMaks = this.$helper.removeThousandSeparator(x.hargaMaksimal);
                payload.append('kondisiHargaMaksimal', nominalHargaMaks)
                if (this.isKendaraan == false) {
                    if (x.dus == 0) {
                        status = true
                    } 
                    else {
                        status = false
                    }
                    payload.append('kondisiDus', status)
                } 
                else {
                    if (x.namaSendiri == 0) {
                        status = true
                    } 
                    else {
                        status = false
                    }
                    payload.append('kondisiNamaSendiri', status)
                }

                payload.append('kondisiKeterangan', x.keterangan || "")

                if (x.detailInfo == "nominal") {
                    let nominalAngka = this.$helper.removeThousandSeparator(x.nominalAngka);
                    payload.append('kondisiNominalAngka', nominalAngka)
                    payload.append('kondisiNominalPersen', null)
                } 
                else {
                    payload.append('kondisiNominalPersen', x.nominalPersen)
                    payload.append('kondisiNominalAngka', null)
                }
            }

            if (this.deleteSpesifikasi && this.deleteSpesifikasi.length > 0) {
                for(var x of this.deleteSpesifikasi){
                    payload.append("deleteSpesifikasiId", x)
                }
            }

            if (this.deleteKondisi && this.deleteKondisi.length > 0) {
                for (var x of this.deleteKondisi) {
                    payload.append("deleteKondisiId", x)
                }
            }

            payload.append("id", this.id)
            payload.append("name", this.input.merkBarang)
            payload.append("jenisBarangId", this.input.jenisBarang)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            
            this.$axios.post("barang-merk/", payload).then(response => {
                this.$helper.setFlash(`Merk barang telah berhasil diubah!`)
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            if (this.input.kondisi.length == 0) {
                this.$helper.toastErr(this, "Tolong masukkan minimal 1 kondisi")
            } 
            else this.$bvModal.show("modal-confirm-edit")
        }

    },

    watch:{

        //----------------- Pantau Jenis Barang -----------------

        'input.jenisBarang': function(id){
            if (this.jenisBarang.length != 0) {
                let jenis = this.jenisBarang.filter(item => item.id == id)
                if (jenis && jenis.length > 0 && jenis[0].jenisPinjaman) {
                    let namaJenis = jenis[0].jenisPinjaman.name
                    if (namaJenis == 'Kendaraan') {
                        this.isKendaraan = true
                    } 
                    else if(namaJenis == 'Elektronik') {
                        this.isKendaraan = false
                    }
                }
            }
        }

    },

    created(){
        this.init()
    }
}
</script>
